// ============================================================================
// src/cattle/cattleRoutes.ts — the cattle domain's route table.
// ============================================================================
// B3.1 finish. The eight clauses that used to be `view === 'X'` tests in
// resolveCattleEntry are this table, and CattleEntry.jsx renders one
// <AppRoute> per row. The table is kept in its own module, free of view
// imports, so it can be read by tests and by the declarative route oracle
// (B2.4) without pulling the Supabase client — and therefore the browser —
// into a node process.
//
// `paths[0]` is the view's canonical path and the one the URL↔view effect
// navigates to; any further entry is another path the same view owns. A
// trailing '/*' means the view owns the record space beneath its path, and
// those splats are not decorative: they are exactly the prefixes the URL→view
// adapter in App maps back to this view, so the two directions agree.
//
//   /cattle/herds/<id>    CattleHerdsView owns the cow record page
//   /cattle/batches/<id>  CattleBatchesRouter owns batch + forecast-month pages
//   /cattle/dailys/<id>   CattleDailysView owns the daily record page
//
// The remaining five views are single, exact paths and must stay exact:
// '/cattle' claiming a splat would swallow every path above it.
// ============================================================================

export const CATTLE_ROUTES = [
  {view: 'cattledailys', paths: ['/cattle/dailys/*']},
  {view: 'cattleHome', paths: ['/cattle']},
  {view: 'cattleherds', paths: ['/cattle/herds/*']},
  {view: 'cattlebreeding', paths: ['/cattle/breeding']},
  {view: 'cattleforecast', paths: ['/cattle/forecast']},
  {view: 'cattlebatches', paths: ['/cattle/batches/*']},
  {view: 'cattlelog', paths: ['/cattle/log']},
  {view: 'cattleweighins', paths: ['/cattle/weighins']},
];
